import React from 'react';
import './admin-menu.css'



export function AdminMenu(props) {
    const [studentTab, setStudentTab] = React.useState(false)
    const [teacherTab, setTeacherTab] = React.useState(false)
    const [billingTab, setBillingTab] = React.useState(false)
    const [menuOpen, setMenuOpen] = React.useState(false)
    const [blogTab, setBlogTab] = React.useState(false)
    React.useEffect(() => {
        studentTab ? document.getElementById('arrow-1').style.transform = "rotate(90deg)" : document.getElementById('arrow-1').style.transform = "rotate(0deg)"
    }, [studentTab])
    React.useEffect(() => {
        teacherTab ? document.getElementById('arrow-2').style.transform = "rotate(90deg)" : document.getElementById('arrow-2').style.transform = "rotate(0deg)"
    }, [teacherTab])
    React.useEffect(() => {
        blogTab ? document.getElementById('arrow-3').style.transform = "rotate(90deg)" : document.getElementById('arrow-3').style.transform = "rotate(0deg)"
    }, [blogTab])
    React.useEffect(() => {
        billingTab ? document.getElementById('arrow-4').style.transform = "rotate(90deg)" : document.getElementById('arrow-4').style.transform = "rotate(0deg)"
    }, [billingTab])

    React.useEffect(() => {
        let adminBubbles = document.getElementsByClassName('user-icon-wrapper__image-circle')
        for(let i = 0; i < adminBubbles.length; i++) {
            adminBubbles[i].style.backgroundColor = "#DEE7EE"
        }
        for(let i = 0; i < props.whosLoggedIn.length; i++) {
            if(props.whosLoggedIn[i].user) {
                document.getElementById(`${props.whosLoggedIn[i].user.replace(/\s/g, '').toLowerCase()}-online-icon-circle`).style.backgroundColor = "green"
            }
        }
    }, [props.whosLoggedIn])

    React.useEffect(() => {
        let allItems = document.getElementsByClassName('admin-menu-item')
        let allWrappers = document.getElementsByClassName('admin-menu-item-wrapper')
        for(let i = 0; i < allItems.length; i++) {
            allItems[i].style.fontWeight = '400'
            allItems[i].style.color = '#8B969F'
        }
        for(let i = 0; i < allWrappers.length; i++) {
            allWrappers[i].style.backgroundColor = '#DEE7EE'
            allWrappers[i].style.border = 'none'
        }
        if(document.getElementById(props.currentView)){document.getElementById(props.currentView).style.fontWeight = '900'}
        if(document.getElementById(props.currentView)){document.getElementById(props.currentView).style.color = '#000221'}
        if(document.getElementById(`wrapper-${props.currentView}`)){document.getElementById(`wrapper-${props.currentView}`).style.backgroundColor = '#B8CEDF'}
        if(document.getElementById(`wrapper-${props.currentView}`)){document.getElementById(`wrapper-${props.currentView}`).style.borderRight = '3px solid #005CA2'}
    }, [props.currentView])

    React.useEffect(() => {
        menuOpen ? document.getElementById('admin-dashboard-menu').style.opacity = 1 : document.getElementById('admin-dashboard-menu').style.opacity = "0.7"
        menuOpen ? document.getElementById('admin-dashboard-menu').style.left = "0px" : document.getElementById('admin-dashboard-menu').style.left = "-150px"
        menuOpen ? document.getElementById('menu-panel-button-arrow').style.transform = "rotate(180deg)" : document.getElementById('menu-panel-button-arrow').style.transform = "rotate(0deg)"
        menuOpen ? document.getElementById('arrow-1').style.opacity = 1 : document.getElementById('arrow-1').style.opacity = 0
        menuOpen ? document.getElementById('arrow-2').style.opacity = 1 : document.getElementById('arrow-2').style.opacity = 0
        menuOpen ? document.getElementById('arrow-3').style.opacity = 1 : document.getElementById('arrow-3').style.opacity = 0
        menuOpen ? document.getElementById('arrow-4').style.opacity = 1 : document.getElementById('arrow-4').style.opacity = 0
        if(document.getElementById('admin-menu-alert-counter')) {
            menuOpen ? document.getElementById('admin-menu-alert-counter').style.opacity = 1 : document.getElementById('admin-menu-alert-counter').style.opacity = 0
        }
        let menuItems = document.getElementsByClassName("admin-menu-item")
        for(let i = 0; i < menuItems.length; i++) {
            menuOpen ? menuItems[i].style.opacity = 1 : menuItems[i].style.opacity = 0;
        }
    })

    return(
        <div className="admin-dashboard-menu" id="admin-dashboard-menu" onMouseEnter={() => setMenuOpen(true)} onMouseLeave={() => setMenuOpen(false)}>
            <div className="menu-header">
                <img alt="new-atharo-logo" src='new-atharo-logo.png' />
            </div>
            <div className="menu-panel-icon-column">
                <div className="menu-panel-open-button" onClick={() => setMenuOpen(!menuOpen)}>
                    <div className="menu-panel-button-arrow" id="menu-panel-button-arrow"></div>
                </div>
                <div className="menu-panel-icon dashboard-icon"></div>
                <div className="menu-panel-icon task-icon"></div>
                <div className="menu-panel-icon students-icon"></div>
                <div className="menu-panel-icon teachers-icon"></div>
                <div className="menu-panel-icon pencil-icon"></div>
                <div className='menu-panel__user-icon-wrapper'>
                    <div className='user-icon-wrapper__image-circle' id='brimassie-online-icon-circle'>
                        <img className='user-icon-image' src='./brimassie.jpg' />
                    </div>
                    <div className='user-icon-wrapper__image-circle' id='courtneymalloy-online-icon-circle'>
                        <img className='user-icon-image' src='./courtneymalloy.jpg' />
                    </div>
                    <div className='user-icon-wrapper__image-circle' id='prescottblackler-online-icon-circle'>
                        <img className='user-icon-image' src='./prescottblackler.jpg' />
                    </div>
                    <div className='user-icon-wrapper__image-circle' id='danityeshaya-online-icon-circle'>
                        <img className='user-icon-image' src='./danityeshaya.jpg' />
                    </div>
                </div>
            </div>
            <div className="admin-menu-item-wrapper first-admin-menu-item" id="wrapper-dashboard">
                <div className="admin-menu-item" onClick={(e) => props.setCurrentView(e.target.id)} id="dashboard" to={'/dashboard'}>Dashboard</div>
            </div>
            <div className="admin-menu-item-wrapper" id="wrapper-tasks">
                <div onClick={(e) => props.setCurrentView(e.target.id)} id="tasks" to={'/admintasks'} className="admin-menu-item">Tasks</div>
            </div>
            <div className="admin-menu-item-wrapper" id="wrapper-calendar">
                <div onClick={(e) => props.setCurrentView(e.target.id)} id="calendar" to={'/calendar'} className="admin-menu-item">Calendar</div>
            </div>
            <div className="admin-menu-item-wrapper">
                <div className="admin-menu-item" onClick={() => setStudentTab(!studentTab)}>Students</div>
                <img src="./arrow-grey.svg" alt="arrow" className="arrow" id="arrow-1" onClick={() => setStudentTab(!studentTab)}/>
            </div>
            {studentTab && 
                <div>
                    <div className="admin-menu-item-wrapper internal" id="wrapper-students">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="students" to={'/admindatabase'} className="admin-menu-item thinner">Database</div>
                    </div>
                    {/* <div className="admin-menu-item-wrapper internal">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="student-onboarding" to={'/adminonboarding'} className="admin-menu-item thinner">Onboarding</div>
                    </div> */}
                    <div className="admin-menu-item-wrapper internal" id="wrapper-student-onboarding2">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="student-onboarding2" to={'/adminonboarding2'} className="admin-menu-item thinner">Onboarding</div>
                    </div>
                    <div className="admin-menu-item-wrapper internal" id="wrapper-families-to-watch">
                    {props.familiesToWatch.length > 0 ? <div className="admin-menu-family-alert-counter" id="admin-menu-family-alert-counter">{props.familiesToWatch.length}</div> : null}
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="families-to-watch" to={'/towatch'} className="admin-menu-item thinner">To Watch</div>
                    </div>
                    <div className="admin-menu-item-wrapper internal" id="wrapper-temp-dashboard">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="temp-dashboard" to={'/tempdashboard'} className="admin-menu-item thinner">Temp Dashboard</div>
                    </div>
                    <div className="admin-menu-item-wrapper internal" id="wrapper-inquiry-database">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="inquiry-database" to={'/inquirydatabase'} className="admin-menu-item thinner">Inquiry Database</div>
                    </div>
                </div>
            }
            <div className="admin-menu-item-wrapper" id="wrapper-">
                <div className="admin-menu-item" onClick={() => setTeacherTab(!teacherTab)}>Teachers</div>
                <img src="./arrow-grey.svg" alt="arrow" className="arrow" id="arrow-2" onClick={() => setTeacherTab(!teacherTab)}/>
            </div>
            {teacherTab && 
                <div>
                    <div className="admin-menu-item-wrapper internal" id="wrapper-teachers">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="teachers" to={'/admin'} className="admin-menu-item thinner">Database</div>
                    </div>
                    <div className="admin-menu-item-wrapper internal" id="wrapper-hiring">
                        {props.applications.length > 0 ? <div className="admin-menu-alert-counter" id="admin-menu-alert-counter">{props.applications.length}</div> : null}
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="hiring" to={'/adminapplications'} className="admin-menu-item thinner">Mgmt</div>
                    </div>
                    {/* <div className="admin-menu-item-wrapper internal">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="teacher-onboarding" to={'/adminonboarding'} className="admin-menu-item thinner">Onboarding</div>
                    </div> */}
                    <div className="admin-menu-item-wrapper internal" id="wrapper-teacher-availability">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="teacher-availability" to={'/adminavailability'} className="admin-menu-item thinner">Availability</div>
                    </div>
                </div>
            }
            <div className="admin-menu-item-wrapper">
                <div className="admin-menu-item" onClick={() => setBillingTab(!billingTab)}>Billing</div>
                <img src="./arrow-grey.svg" alt="arrow" className="arrow" id="arrow-4" onClick={() => setBillingTab(!billingTab)}/>
            </div>
            {billingTab &&
                <div>
                    <div className="admin-menu-item-wrapper internal" id="wrapper-billing">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="billing" to={'/billing'} className="admin-menu-item thinner">Timesheets</div>
                    </div>
                    <div className="admin-menu-item-wrapper internal" id="wrapper-cancellations">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="cancellations" to={'/cancellations'} className="admin-menu-item thinner">Cancellations</div>
                    </div>
                    {props.userData.Name === 'Prescott Blackler' &&
                        <div className="admin-menu-item-wrapper internal" id="wrapper-tax-info">
                            <div onClick={(e) => props.setCurrentView(e.target.id)} id="tax-info" to={'/tax-info'} className="admin-menu-item thinner">Tax Info</div>
                        </div>
                    }
                </div>
            }
            <div className="admin-menu-item-wrapper">
                <div className="admin-menu-item" onClick={() => setBlogTab(!blogTab)}>Blogs</div>
                <img src="./arrow-grey.svg" alt="arrow" className="arrow" id="arrow-3" onClick={() => setBlogTab(!blogTab)}/>
            </div>
            {blogTab &&
                <div>
                    <div className="admin-menu-item-wrapper internal" id="wrapper-blog">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="blog" to={'/blog'} className="admin-menu-item thinner">Write Blog</div>
                    </div>
                    <div className="admin-menu-item-wrapper internal" id="wrapper-mydrafts">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="mydrafts" to={'/mydrafts'} className="admin-menu-item thinner">My Drafts</div>
                    </div>
                    <div className="admin-menu-item-wrapper internal" id="wrapper-review">
                        <div onClick={(e) => props.setCurrentView(e.target.id)} id="review" to={'/review'} className="admin-menu-item thinner">Review</div>
                    </div>
                </div>

            }
            <div className="admin-menu-item-wrapper">
                <a className="admin-menu-item" href="https://sites.google.com/view/atharowiki" rel="noopener noreferrer" target="_blank">Wiki</a>
            </div>
            <div className="admin-menu-item-wrapper" id="wrapper-school-seo">
                <div onClick={(e) => props.setCurrentView(e.target.id)} id="school-seo" to={'/school-seo'} className="admin-menu-item">School SEO</div>
            </div>
            <div className="admin-menu-item-wrapper">
                <div className="admin-menu-item" onClick={() => props.logout()}>Log Out</div>
            </div>
        </div>
    )
}